import {Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import React, {useCallback, useEffect, useState} from "react";
import {useEffectOnce} from "../hooks/useEffectOnce";
import * as UserService from "../api/UserService";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import Style from "./Style.module.css";
import {useTranslation} from "react-i18next";
import AvailableFieldsPreviewSelector from "./AvailableFieldsPreviewSelector";

function AvailableStylesSelector(props) {
    const [availableStyles, setAvailableStyles] = useState([])
    const [availableDecks, setAvailableDecks] = useState([])
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'fieldStyleSelector'});

    const [showPreviewModal, setShowPreviewModal] = useState(false)

    const alertMessage = t('smthWentWrongMessage')

    const defaultStyle = {
        "id": 2,
        "name": "Спокій",
        "name_ua": "Спокій",
        "name_en": "Calm",
        "deduplication_code": "CALM",
        "deduplication_priority": 0,
        "preview_img_url": "https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefield_previews_small/2medium.jpeg",
        "bg_img_url": "https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/game_field_calm.png",
        "bg_colors": "#aaacba, #aaacba, #7a7e98, #263076",
        "list_display_priority": 0,
        "favourite": false
    }

    const getAvailableFieldStyles = useCallback(() => {
        UserService.getAvailableGameFieldStyles(
            (styles) => {
                setAvailableStyles(styles)
                if (props.selectedStyle === 0) {
                    console.log(styles)
                    const favStyles = styles.filter(s => s.favourite)
                    if (favStyles.length > 0) {
                        props.setSelectedStyle({"target": {"value": favStyles[0].id}})
                    } else {
                        props.setSelectedStyle({"target": {"value": styles[0].id}})
                    }
                }
            },
            () => setAvailableStyles([defaultStyle])
        )
    }, [])

    useEffectOnce(() => {
        UserService.getAvailableGameFieldStyles(
            (styles) => {
                setAvailableStyles(styles)
                if (props.selectedStyle === 0) {
                    console.log(styles)
                    const favStyles = styles.filter(s => s.favourite)
                    console.log(favStyles)
                    if (favStyles.length > 0) {
                        props.setSelectedStyle({"target": {"value": favStyles[0].id}})
                    } else {
                        props.setSelectedStyle({"target": {"value": styles[0].id}})
                    }
                }
            },
            () => setAvailableStyles([defaultStyle])
        )
    })

    useEffect(() => {
        if (props.selectedStyle === 0) {
            return
        }
        getAvailableCardDecks(props.selectedStyle)
    }, [props.selectedStyle]);

    useEffect(() => {
        if (availableDecks.length > 0) {
            props.setDefaultDeck(availableDecks[0]?.id + "-" + availableDecks[0]?.type)
        }

    }, [availableDecks])

    function getAvailableCardDecks(fieldStyleId) {
        UserService.getAvailableCardDecksForFieldStyle(
            (decks) => {
                setAvailableDecks(decks)
                if (!props.selectedDeck && decks.length > 0) {
                    props.setSelectedDeck({"target": {"value": decks[0].id + "-" + decks[0].type}})
                } else {
                    const avail_decks_vals = decks.map(deck => deck.id + "-" + deck.type)
                    if (!avail_decks_vals.includes(props.selectedDeck) && decks.length > 0) {
                        props.setSelectedDeck({"target": {"value": decks[0].id + "-" + decks[0].type}})
                    }
                }

            },
            () => window.alert(alertMessage),
            fieldStyleId
        )
    }

    const renderPreviewTooltip = (props) => (
        <Tooltip className="alternativeVideoTooltip" id="styles-preview-tooltip" {...props}>
            <div>{t('seeAllTooltip')}</div>
        </Tooltip>
    )

    function getFieldNameById(id) {
        for (const style of availableStyles) {

            if (style.id.toString() === id.toString()) {
                return i18n.language === "en" ? style.name_en : style.name_ua
            }
        }
    }

    return <>
        <Form.Label className={Style.bodyBaseText}>{t('fieldStyle')}</Form.Label>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "5px"}}>
            <input
                style={{width: "100%", border: "#dee3e6 solid 1px", borderRadius: "0.375rem", height: "38px", paddingLeft: "12px", cursor: "pointer"}}
                onClick={() => setShowPreviewModal(true)}
                readOnly={true}
                value={getFieldNameById(props.selectedStyle)}
            />
            {showPreviewModal && <AvailableFieldsPreviewSelector
                show={showPreviewModal}
                onClose={() => setShowPreviewModal(false)}
                availableStyles={availableStyles}
                setSelectedStyle={props.setSelectedStyle}
                selectedStyle={props.selectedStyle}
                getAvailableFieldStyles={getAvailableFieldStyles}
            />}
            <OverlayTrigger placement="top-start" delay={{show: 150, hide: 250}}
                            overlay={renderPreviewTooltip}>
                <a href={i18n.language === "en" ? "/preview_field_styles_en" : "/preview_field_styles"} target="_blank"><RemoveRedEyeOutlinedIcon/></a>

            </OverlayTrigger>
        </div>
        <Form.Label className={Style.bodyBaseText} style={{marginTop: "12px"}}>{t('cards')}</Form.Label>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "5px", marginTop: "12px"}}>
            <Form.Select
                onChange={props.setSelectedDeck}
                value={props.selectedDeck}
            >
                {availableDecks.map((deck) => {
                    return <option key={deck.id} value={deck.id + "-" + deck.type}>
                        {i18n.language === "en" ? deck.name_en : deck.name}
                    </option>
                })}

            </Form.Select>
        </div>

    </>

}


export default AvailableStylesSelector